<template>
  <!-- Страница помощи: адрес для Support URL в App Store и RuStore и для
       любого, кто ищет, куда написать. Публичная, вход не нужен (/help/ в
       publicPaths роутера). Ссылки те же, что в настройках профиля. -->
  <div class="support-page" style="font-family: Inter, sans-serif;">
  <div class="w-full max-w-[440px] mx-auto px-3 pt-10 pb-6">
    <button v-if="authStore.token" @click="$router.push('/profile')" class="mb-2 text-ink" aria-label="Назад">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg>
    </button>

    <div class="flex justify-center mb-3">
      <img src="/icon-apple.png" width="72" height="72" alt="Зоя" class="rounded-[16px] shadow-md" />
    </div>

    <h1 class="text-26 font-bold text-ink mb-1 text-center">Помощь и поддержка</h1>
    <p class="text-16 text-ink mb-5 text-center">Что-то не работает, есть вопрос или идея? Напишите нам.</p>

    <div class="text-16 text-ink leading-relaxed">

      <!-- Почта -->
      <div class="bg-white rounded-2xl p-4 mb-3">
        <div class="font-bold text-18 mb-1">Поддержка</div>
        <p class="text-15 leading-snug mb-4">
          Вопросы о работе приложения, оплате и аккаунте, ошибки и предложения — пишите, ответим.
        </p>
        <a
          href="mailto:m@zozhnik.ru"
          class="block w-full py-3.5 rounded-2xl bg-ink text-white text-16 font-semibold text-center no-underline active:opacity-90 transition-opacity"
        >
          Написать на m@zozhnik.ru
        </a>
      </div>

      <!-- Telegram -->
      <div class="bg-white rounded-2xl p-4 mb-3">
        <div class="font-bold text-18 mb-1">Сообщество в Telegram</div>
        <p class="text-15 leading-snug mb-4">
          Новости, обсуждения и идеи пользователей Зои.
        </p>
        <a
          href="https://t.me/+TaXmJC3u3wQ5OWQy"
          target="_blank"
          rel="noopener"
          class="flex items-center justify-center gap-2.5 w-full py-3.5 rounded-2xl bg-[#2AABEE] text-white text-16 font-semibold text-center no-underline active:opacity-90 transition-opacity"
        >
          <svg width="20" height="20" viewBox="0 0 240 240" class="shrink-0" aria-hidden="true">
            <circle cx="120" cy="120" r="120" fill="#fff"/>
            <path d="M98 175c-3.9 0-3.2-1.5-4.6-5.2L82 132.2 170.4 78" fill="#C8DAEA"/>
            <path d="M98 175c3 0 4.3-1.4 6-3l16-15.6-20-12" fill="#A9C9DD"/>
            <path d="M100 144.4l48.4 35.7c5.5 3 9.5 1.5 10.9-5.1l19.7-92.8c2-8.1-3.1-11.8-8.4-9.4L55 117.4c-7.9 3.2-7.8 7.6-1.4 9.5l29.7 9.3 68.7-43.3c3.2-2 6.2-.9 3.8 1.3" fill="#fff"/>
          </svg>
          Открыть группу в Telegram
        </a>
      </div>

      <!-- Полезные ссылки -->
      <div class="bg-white rounded-2xl p-4 mb-3">
        <div class="font-bold text-18 mb-2">Полезные ссылки</div>
        <router-link to="/help/install" class="block py-2 text-15 text-ink underline">Как установить приложение</router-link>
        <router-link to="/legal/terms" class="block py-2 text-15 text-ink underline">Пользовательское соглашение</router-link>
        <router-link to="/legal/privacy" class="block py-2 text-15 text-ink underline">Политика персональных данных</router-link>
        <p class="text-14 text-[#7a6656] leading-snug mt-2">
          Удалить аккаунт вместе со всеми данными можно самостоятельно: профиль → Аккаунт → «Удалить аккаунт навсегда».
        </p>
      </div>

      <p class="text-13 text-ink/70 text-center mt-6">
        Зоя — проект <a href="https://zozhnik.ru" target="_blank" rel="noopener" class="underline">Зожника</a>
      </p>
    </div>
  </div>
  </div>
</template>

<script setup>
import { useAuthStore } from '../store/auth.js'

const authStore = useAuthStore()
</script>

<style scoped>
.support-page {
  position: fixed;
  inset: 0;
  background: #FAF3E8;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 50;
}
</style>
